<template>
  <div>
    <az-back-button :route="{name: 'protocolosLista', params: {tipo: this.tipo}}" text="Voltar para listagem"></az-back-button>
    <az-container>
      <az-formbar>
        <div class="show">
          <div class="itens">
            <div class="item" v-if="tipo === 'PROTOCOLO_DOCUMENTO'">
              <label>Protocolo</label>
              <span>{{ dados.protocolo | textoSemValor }}</span>
            </div>
            <div class="item">
              <label>Fornecedor</label>
              <span>{{ dados.razaoSocialFornecedor | textoSemValor }}</span>
            </div>
            <div class="item">
              <label>Situação</label>
              <span>{{ dados.situacao | textoSemValor }}</span>
            </div>
          </div>
          <v-btn outline class="btn-protocolo-detalhe-baixar"
                 @click="baixarProtocolo">
            Baixar
          </v-btn>
        </div>
      </az-formbar>
      <div class="az-form-content">
        <v-container fluid grid-list-xl>
          <v-layout wrap align-center>
            <v-flex xs12 sm3 d-flex>
              <div class="az-text">
                <label>Processo</label>
                <p>{{ dados.processo | textoSemValor }}</p>
              </div>
            </v-flex>
            <v-flex xs12 sm3 d-flex>
              <div class="az-text">
                <label>Origem</label>
                <p>{{ dados.origem | textoSemValor }}</p>
              </div>
            </v-flex>
            <v-flex xs12 sm3 d-flex>
              <div class="az-text">
                <label>Data Hora Envio</label>
                <p>{{ dados.dataHora | az-date('DD/MM/YYYY HH:mm:ss') }}</p>
              </div>
            </v-flex>
            <v-flex xs12 sm3 d-flex>
              <div class="az-text">
                <label>Hash</label>
                <p>{{ dados.hash | textoSemValor }}</p>
              </div>
            </v-flex>
            <v-flex xs12 sm12 d-flex>
              <div class="az-text">
                <label>Nome documento principal</label>
                <p>{{ dados.nome | textoSemValor }}</p>
              </div>
            </v-flex>
            <v-flex xs12 sm12 d-flex class="protocolo-detalhe-titulo-container">
              <span class="protocolo-detalhe-titulo primary--text">Destino do Documento</span>
            </v-flex>
            <v-flex xs12 sm3 d-flex>
              <div class="az-text">
                <label>Pregão</label>
                <p>{{ dados.edital | textoSemValor }}</p>
              </div>
            </v-flex>
            <v-flex xs12 sm3 d-flex>
              <div class="az-text">
                <label>Repetição</label>
                <p>{{ dados.repeticao | textoSemValor }}</p>
              </div>
            </v-flex>
            <v-flex xs12 sm3 d-flex>
              <div class="az-text">
                <label>Critério Classificação</label>
                <p>{{ dados.criterioClassificacao | textoSemValor }}</p>
              </div>
            </v-flex>
            <v-flex xs12 sm3 d-flex>
              <div class="az-text">
                <label>Tipo</label>
                <p>{{ dados.tipo | textoSemValor }}</p>
              </div>
            </v-flex>
            <v-flex xs12 sm12 d-flex class="protocolo-detalhe-titulo-container">
              <span class="protocolo-detalhe-titulo primary--text">Dados Responsável pelo Envio</span>
            </v-flex>
            <v-flex xs12 sm3 d-flex>
              <div class="az-text">
                <label>Responsável</label>
                <p>{{ dados.responsavelEnvio | textoSemValor }}</p>
              </div>
            </v-flex>
            <v-flex xs12 sm3 d-flex>
              <div class="az-text">
                <label>CPF</label>
                <p>{{ dados.cpfResponsavelEnvio | az-cpf-cnpj }}</p>
              </div>
            </v-flex>
            <v-flex xs12 sm3 d-flex>
              <div class="az-text">
                <label>E-mail</label>
                <p>{{ dados.emailResponsalvelEnvio | textoSemValor }}</p>
              </div>
            </v-flex>
            <v-flex xs12 sm12 d-flex class="protocolo-detalhe-titulo-container">
              <span class="protocolo-detalhe-titulo primary--text">Dados Fornecedor</span>
            </v-flex>
            <v-flex xs12 sm3 d-flex>
              <div class="az-text">
                <label>Responsável</label>
                <p>{{ dados.razaoSocialFornecedor | textoSemValor }}</p>
              </div>
            </v-flex>
            <v-flex xs12 sm3 d-flex>
              <div class="az-text">
                <label>CNPJ</label>
                <p>{{ dados.cnpjFornecedor | az-cpf-cnpj }}</p>
              </div>
            </v-flex>
            <v-flex xs12 sm12 d-flex class="protocolo-detalhe-titulo-container">
              <span class="protocolo-detalhe-titulo primary--text">Anexos</span>
            </v-flex>
            <ul  class="protocolo-detalhe-anexos">
              <li v-for="(anexo) in dados.anexos" :key="anexo.id">
                <span>{{ anexo.nome | textoSemValor }} - Hash: {{ anexo.hash | textoSemValor }}</span>
              </li>
            </ul>
          </v-layout>
        </v-container>
      </div>
    </az-container>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import {actionTypes} from "@/commons/constants";

export default {
  name: "ProtocoloDetalhe",
  data() {
    return {
      documentoId: null,
      tipo: null,
      dados: {}
    }
  },
  async mounted() {
    this.setarDados()
    await this.buscar()
  },
  methods: {
    ...mapActions([
      actionTypes.BUSCAR_PROTOCOLO_DETALHE,
      actionTypes.GERAR_RECIBO_DE_PROTOCOLO
    ]),
    setarDados() {
      if (this.$route.params.id && this.$route.params.tipo) {
        this.documentoId = this.$route.params.id
        this.tipo = this.$route.params.tipo
      }
    },
    async buscar() {
      const resultado = await this.buscarProtocoloDetalhe({documentoId: this.documentoId, tipo: this.tipo})
      if (resultado) {
        this.dados = resultado
      }
    },
    async baixarProtocolo() {
      await this.gerarReciboDeProtocolo({documentoId: this.documentoId, tipo: this.tipo})
    }
  }
}
</script>

<style scoped lang="stylus">

.item
  label
    font-weight bold

.btn-protocolo-detalhe-baixar
  color white !important
  border-radius 5px

.protocolo-detalhe-titulo-container
  padding 0px 12px !important

.protocolo-detalhe-titulo
  font-weight bold

.protocolo-detalhe-anexos
  list-style none
  font-size 13px
  color #888
  padding 12px
  margin-bottom 50px


</style>